import Component from '../abstracts/Component';
import PasswordRecoveryLogic from '../logics/PasswordRecoveryLogic';
export default class PasswordRecoveryComponent extends Component {

  get COMPONENTNAME(){
    return "PasswordRecoveryComponent"
  }

  get SELECTORS() {
    return {
      label: '.pwd-recovery-label',
      returnToLoginLbl: '.return-to-login-lbl',
      credentialsLayer: '.credentials-layer',
      forgotPasswordLayer: '.forgot-password-layer',
      btnSubmit: '.submit-recovery-psw',
      formClass: "#forgottenPwdForm",
      wrapperContent: ".f-p-l-wrapper-content",
      successFPsw: ".success-forgot-psw",
      wrtl: ".w-r-t-l-lbl",
      currentPswd: ".current_pwd",
      oldPswd: ".new_pwd",
      buttonPrimary: ".pwd-recovery-submit-btn"
    };
  }


  constructor() {
    super();
  }

  bindEvents() {
    let credentialLayer = document.querySelectorAll(this.SELECTORS.credentialsLayer);
    let forgotPasswordLayer = document.querySelectorAll(this.SELECTORS.forgotPasswordLayer);
    let btn = document.querySelectorAll(this.SELECTORS.btnSubmit);
    let form = document.querySelector(this.SELECTORS.formClass);
    let wc = document.querySelector(this.SELECTORS.wrapperContent);
    let sfp = document.querySelector(this.SELECTORS.successFPsw);
    let wrtl = document.querySelector(this.SELECTORS.wrtl);
    let currentPswd = document.querySelector(this.SELECTORS.currentPswd);
    let oldPswd = document.querySelector(this.SELECTORS.oldPswd);
    let buttonPrimary = document.querySelector(this.SELECTORS.buttonPrimary);

    this.$on('click', ({ event }) => {
      event.preventDefault();
      credentialLayer.forEach((layer)=> {
        layer.style.display= "block";
      });
      forgotPasswordLayer.forEach((forgotLayer)=> {
        forgotLayer.style.display = "none";
      })
    }, 'body', this.SELECTORS.returnToLoginLbl);

    this.$on('click', ({ event }) => {
      event.preventDefault();
      credentialLayer.forEach((layer)=> {
        layer.style.display = "none";
      })
      forgotPasswordLayer.forEach((forgotLayer)=> {
        forgotLayer.style.display = "block";
      })
    }, 'body', this.SELECTORS.label);

    currentPswd && currentPswd.addEventListener('input', () => this.toggleButtonState(currentPswd, oldPswd, buttonPrimary));
    oldPswd && oldPswd.addEventListener('input', () => this.toggleButtonState(currentPswd, oldPswd, buttonPrimary));
    if(btn){
      btn.forEach(submitBtn => {
        submitBtn.addEventListener("click", (e) => {
          let url = form.getAttribute("action");
          let params = new URLSearchParams(new FormData(form)).toString();
    
          this.$doAjax({
            type: 'POST',
            url: url,
            data: params
          })
            .done(res => {
              console.log('Recovery password...');
              let html = new DOMParser().parseFromString(res, 'text/html');
              wc.style.display = "none";
              wrtl.style.display = "none";
              sfp.style.display = "block";
              //newsletterBox.classList.add(ctx.CLASSES.success);
              // emit event
              //ctx.$emit(ctx.$customEvents[eventsName].subscribed, {box: newsletterBox});
              // removing loading class
              //newsletterBox.classList.remove('loading');
            })
            .fail(xhr => {
              console.log(`nl submit error:  ${$(this).serialize()}`);
              console.log(xhr);
            })
            .always(() => {
              console.log("finished")
            });
        })
      })
    }
  }

  toggleButtonState = (currentPswd, oldPswd, buttonPrimary) => {
    const inputsNotEmpty = currentPswd.value.trim() !== '' && oldPswd.value.trim() !== '';
    if(inputsNotEmpty) {
      buttonPrimary.removeAttribute('disabled');
      buttonPrimary.classList.remove('disabled');
    }
  };

  render() {
    this.log("Rendering...")
    this.PasswordRecoveryLogic = new PasswordRecoveryLogic();
    this.bindEvents();
  }
}
